import { Divider, Text, Title } from "@mantine/core";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import UpdateChecker from "src/components/shared/UpdateChecker";
import { getOrigin } from "src/environment";
import { PageContainer } from "src/styled";

import styles from "./DesktopApp.module.scss";
import {
  CardContainer,
  CardsRow,
  PageContent,
  SystemImage,
} from "./DesktopApp.styled";

const disabledAppStores = false;

const DesktopApp = () => {
  return (
    <PageContainer>
      <Breadcrumbs />
      <PageContent>
        {window?.api && (
          <>
            <Title order={3} className={styles.sectionTitle}>
              Desktop App Updates
            </Title>
            <UpdateChecker />
            <Divider my="md" style={{ width: "100%", maxWidth: "600px" }} />
          </>
        )}

        {!window?.api && (
          <>
            <Title order={3} className={styles.sectionTitle}>
              Download Desktop App
            </Title>
            <CardsRow>
              <CardContainer
                href={getOrigin() + "/api/v1/apps/DeskApp/eLogbooks-mac.dmg"}>
                <SystemImage src="/assets/Apple.svg" />
                <Text size="sm" ta="center" mt="sm">
                  Download Mac OS (Desktop)
                </Text>
              </CardContainer>
              <CardContainer
                href={getOrigin() + "/api/v1/apps/DeskApp/eLogbooks-win.exe"}>
                <SystemImage src="/assets/Windows.svg" />
                <Text size="sm" ta="center" mt="sm">
                  Download Windows (Desktop)
                </Text>
              </CardContainer>
            </CardsRow>
            <Divider my="md" style={{ width: "100%", maxWidth: "600px" }} />
          </>
        )}

        <Title order={3} className={styles.sectionTitle}>
          Mobile & Tablet Apps
        </Title>
        <CardsRow>
          <CardContainer
            disabled={disabledAppStores}
            href="https://apps.apple.com/gb/app/elogbooks/id6479199806">
            <SystemImage src="assets/app-store.svg" />
            <Text size="sm" ta="center" mt="sm">
              Download App Store (Tablet)
            </Text>
          </CardContainer>
          <CardContainer
            disabled={disabledAppStores}
            href="https://play.google.com/store/apps/details?id=com.ljelogbooks.eLogbooks">
            <SystemImage src="assets/google-play.svg" />
            <Text size="sm" ta="center" mt="sm">
              Download Google Play (Tablet)
            </Text>
          </CardContainer>
          <CardContainer
            disabled={disabledAppStores}
            href="https://www.amazon.co.uk/dp/B0CXKBG6P8">
            <SystemImage src="assets/Amazon_icon.svg" />
            <Text size="sm" ta="center" mt="sm">
              Download Amazon (Tablet)
            </Text>
          </CardContainer>
        </CardsRow>
      </PageContent>
    </PageContainer>
  );
};

export default DesktopApp;
